export const getTrendColor = (value: number) => {
  const sign = Math.sign(value).toString(10);
  const text: Record<string, 'neg' | 'text' | 'pos'> = {
    '-1': 'neg',
    '0': 'text',
    '1': 'pos',
  };
  return text[sign];
};
